import Keycloak from 'keycloak-js'
import { RestChatService } from '@repo/network'
import ReactGA from 'react-ga4'
import { KeycloakUserInfo } from '@web/modules/core'

export const enableAnalytics = async (kcInstance: Keycloak) => {
  try {
    const { userInfo, realm } = kcInstance
    const currentUser: KeycloakUserInfo = userInfo as KeycloakUserInfo
    const { connectionKeys } = await RestChatService.info()
    const keycloakId = currentUser.sub

    ReactGA.initialize(import.meta.env.VITE_GA_ID, {
      gaOptions: {
        chatVersion: import.meta.env.VITE_VERSION,
        keycloakId,
        connectionKeys: connectionKeys?.join(', ') ?? '',
        realm
      },
      gtagOptions: {
        send_page_view: false
      }
    })
    console.log('Analytics enabled')
  } catch (e) {
    console.log('Fail to enable analytics:\n', e)
  }
}

export enum EventOrigin {
  button = 'button',
  modal = 'modal',
  select = 'select',
  input = 'input'
}

export enum EventGoal {
  submit = 'submit',
  filter = 'filter',
  download = 'download',
  cancel = 'cancel',
  closeModal = 'close_modal',
  click = 'click'
}

interface EventParams {
  action?: string
  origin?: EventOrigin
  goal?: EventGoal
  department?: string
  platform?: string
  connectionKey?: string
}

interface EventProps {
  name: string
  params: EventParams
}

export const logEvent = (event: EventProps) => {
  ReactGA.event(event.name, event.params)
}
